export const GROUP_BY = {
  DATE: 'DATE',
  WEEK: 'WEEK'
};
